import { useEffect, useState } from "react";
import { Copy, KeyRound, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, slDateTime } from "@/lib/api";
import { inputCls } from "@/pages/Login";

const genPass = () => { const a = "abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789"; const r = new Uint32Array(12); window.crypto.getRandomValues(r); return [...r].map((x) => a[x % a.length]).join(""); };

function CredBox({ cred, onClose }) {
  const text = `Prijava: ${window.location.origin}/prijava\nE-pošta: ${cred.email}\nGeslo: ${cred.password}`;
  return (
    <div className="card-lux p-5 bg-[#F5EFE6] space-y-2" data-testid="customer-credentials-box">
      <div className="flex justify-between"><b className="text-sm">Podatki za prijavo stranke</b><button onClick={onClose} aria-label="Zapri"><X size={16} /></button></div>
      <pre className="text-sm whitespace-pre-wrap font-sans">{text}</pre>
      <button onClick={() => { navigator.clipboard.writeText(text); toast.success("Kopirano."); }} className="btn-dark px-4 py-2 text-xs flex items-center gap-2" data-testid="customer-credentials-copy"><Copy size={14} /> Kopiraj za posredovanje</button>
    </div>
  );
}

export default function CustomersPanel() {
  const [list, setList] = useState([]);
  const [weddings, setWeddings] = useState([]);
  const [f, setF] = useState({ name: "", email: "", password: genPass(), wedding_id: "" });
  const [cred, setCred] = useState(null);
  const load = () => api.get("/admin/customers").then((r) => setList(r.data));
  useEffect(() => { load(); api.get("/admin/weddings").then((r) => setWeddings(r.data)); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/customers", { ...f, wedding_id: f.wedding_id || null });
      setCred({ email: f.email.toLowerCase(), password: f.password });
      setF({ name: "", email: "", password: genPass(), wedding_id: "" });
      load();
    } catch (er) { toast.error(errMsg(er)); }
  };
  const reset = async (u) => {
    const pw = genPass();
    if (!window.confirm(`Nastavim novo geslo za ${u.email}?`)) return;
    try { await api.patch(`/admin/customers/${u.id}`, { password: pw }); setCred({ email: u.email, password: pw }); } catch (er) { toast.error(errMsg(er)); }
  };
  const grant = async (u, wid) => { if (!wid) return; try { await api.post(`/admin/customers/${u.id}/weddings`, { wedding_id: wid }); load(); } catch (er) { toast.error(errMsg(er)); } };
  const revoke = async (u, wid) => { if (!window.confirm("Odvzamem dostop do poroke?")) return; await api.delete(`/admin/customers/${u.id}/weddings/${wid}`); load(); };

  return (
    <div className="grid lg:grid-cols-[24rem_1fr] gap-6" data-testid="admin-customers">
      <div className="space-y-4">
        <form onSubmit={create} className="card-lux p-6 space-y-3">
          <h3 className="font-display text-2xl">Nov profil stranke</h3>
          <input className={inputCls} required placeholder="Ime (npr. Jan in Mateja)" value={f.name} onChange={set("name")} data-testid="customer-name-input" />
          <input className={inputCls} required type="email" placeholder="E-pošta za prijavo" value={f.email} onChange={set("email")} data-testid="customer-email-input" />
          <div className="flex gap-2">
            <input className={inputCls} required minLength={8} placeholder="Geslo" value={f.password} onChange={set("password")} data-testid="customer-password-input" />
            <button type="button" onClick={() => setF({ ...f, password: genPass() })} className="btn-line px-3" title="Ustvari geslo" data-testid="customer-generate-password"><KeyRound size={16} /></button>
          </div>
          <select className={inputCls} value={f.wedding_id} onChange={set("wedding_id")} data-testid="customer-wedding-select"><option value="">Brez poroke (dodelite kasneje)</option>{weddings.map((w) => <option key={w.id} value={w.id}>{w.title} · {w.wedding_date}</option>)}</select>
          <button className="btn-dark w-full h-12" data-testid="customer-create-submit">Ustvari profil</button>
          <p className="text-xs text-[#6C6560]">Stranka se prijavi na strani Prijava z e-pošto in geslom, ki ju posredujete.</p>
        </form>
        {cred && <CredBox cred={cred} onClose={() => setCred(null)} />}
      </div>
      <div className="card-lux p-6 space-y-3">
        <h3 className="font-display text-2xl">Stranke ({list.length})</h3>
        {list.map((u) => (
          <div key={u.id} className="border-b border-[#EADBCE]/60 pb-3 text-sm space-y-2" data-testid="customer-row">
            <div className="flex flex-wrap justify-between gap-2"><div><b>{u.name}</b> · <span className="text-[#6C6560]">{u.email}</span><p className="text-xs text-[#968E87]">Ustvarjeno {slDateTime(u.created_at)}{u.created_by ? ` · ${u.created_by}` : ""}</p></div>
              <button onClick={() => reset(u)} className="btn-line px-3 py-1.5 text-xs flex items-center gap-1" data-testid="customer-reset-password"><KeyRound size={12} /> Novo geslo</button></div>
            <div className="flex flex-wrap gap-2 items-center">
              {u.weddings.map((w) => <span key={w.id} className="text-xs px-3 py-1 rounded-full bg-[#F3ECE1] flex items-center gap-1">{w.title}<button onClick={() => revoke(u, w.id)} aria-label="Odvzemi" data-testid="customer-revoke-wedding"><X size={12} /></button></span>)}
              <select value="" onChange={(e) => grant(u, e.target.value)} className="text-xs border border-[#DFD5C5] rounded-full px-2 py-1 bg-white" data-testid="customer-grant-wedding"><option value="">+ Dodeli poroko</option>{weddings.filter((w) => !u.weddings.some((x) => x.id === w.id)).map((w) => <option key={w.id} value={w.id}>{w.title}</option>)}</select>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
